import { FoundationProject } from '@models';

export interface ClaEnabledProjectsResult {
  claEnabledProjects: FoundationProject[];
}
